import axios from 'axios'
import { BUSCAR_EMPRESAS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarEmpresa (codigoEmpresa) {
  let url = `${URL}/empresas/todas`;
  if(codigoEmpresa != null && codigoEmpresa != 0) {
    url += `?codigoEmpresa=${codigoEmpresa}`
  }
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_EMPRESAS,
        payload: response

      })
  );
}
